import { stateLabel } from './display-copy';
import { useState } from 'react';
import type { OemWorkspace } from '../../lib/oem-client';
import { customerTimeline, milestoneStages } from './milestone-timeline-model';
import { deadlineText } from './task-dashboard-model';
export function MilestoneTimeline({
  workspace,
  link,
}: {
  workspace: OemWorkspace;
  link: (key: string) => string;
}) {
  const [sku, setSku] = useState('');
  const [category, setCategory] = useState('all');
  const timeline = customerTimeline(workspace, sku, category);
  const reset = () => {
    setSku('');
    setCategory('all');
  };
  return (
    <section className="card milestone-timeline" aria-label="ติดตามงานของคุณ">
      <h2>ติดตามงานของคุณ</h2>
      <p className="muted">
        หลักฐานในขอบเขตของคุณ · เวอร์ชันล่าสุดที่มองเห็น ไม่ใช่ผลอนุมัติหรือความพร้อมผลิต
      </p>
      <div className="daily-filters">
        <label>
          สินค้าในโครงการ
          <select
            aria-label="สินค้าในโครงการ"
            value={sku}
            onChange={(event) => setSku(event.target.value)}
          >
            <option value="">ทุก SKU</option>
            <option value="project">งานรวมของโครงการ</option>
            {workspace.skus.map((s) => (
              <option key={s.id} value={s.id}>
                {s.label}
              </option>
            ))}
          </select>
        </label>
        <label>
          ช่วงของงาน
          <select
            aria-label="ช่วงของงาน"
            value={category}
            onChange={(event) => setCategory(event.target.value)}
          >
            <option value="all">ทุกช่วง</option>
            {milestoneStages.map((stage) => (
              <option key={stage.key} value={stage.key}>
                {stage.label}
              </option>
            ))}
          </select>
        </label>
        <button type="button" className="text-button" onClick={reset}>
          ล้างตัวกรองเส้นทาง
        </button>
      </div>
      <p role="status">พบ {timeline.total} รายการที่มองเห็น</p>
      <ol className="milestone-stages">
        {timeline.stages.map((stage) => (
          <li key={stage.key}>
            <details open={category === stage.key || stage.key === 'brief'}>
              <summary>
                <strong>{stage.label}</strong>
                <span>
                  {stage.entries.length
                    ? `${stage.entries.length} รายการที่มองเห็น`
                    : 'ยังไม่พบในขอบเขตนี้'}
                </span>
              </summary>
              {stage.entries.length === 0 ? (
                <p className="muted">ยังไม่ทราบ · อาจยังไม่บันทึกหรืออยู่นอกสิทธิ์ของคุณ</p>
              ) : (
                <ul className="milestone-evidence">
                  {stage.entries.map((entry) => (
                    <li key={entry.id}>
                      <strong>{entry.label}</strong>
                      <p>
                        v{entry.version} · สถานะ: {stateLabel(entry.state)}
                      </p>
                      <p className="muted">วันที่บันทึก: {deadlineText(entry.date)}</p>
                      {entry.nextAction && <p>{entry.nextAction}</p>}
                      {entry.route && (
                        <a className="text-button" href={link(entry.route.path)}>
                          {entry.route.label}
                        </a>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </details>
          </li>
        ))}
      </ol>
      {timeline.total === 0 && (
        <button className="action secondary" type="button" onClick={reset}>
          แสดงทุกช่วงที่มองเห็น
        </button>
      )}
      <section className="milestone-frozen" aria-label="ข้อมูลที่ยืนยันไว้">
        <h3>ข้อมูลที่ยืนยันไว้</h3>
        {timeline.frozen ? (
          <>
            <p className="wrap">ชุดยืนยัน {timeline.frozen.id}</p>
            <p>{deadlineText(timeline.frozen.date)}</p>
            <p className="muted">ข้อมูลในวันที่ยืนยัน แยกจากร่างล่าสุดด้านบน</p>
            {timeline.frozen.versions.length ? (
              <ul>
                {timeline.frozen.versions.map((version) => (
                  <li key={version.id}>
                    {version.label} · v{version.version}
                    <small className="wrap">{version.id}</small>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="muted">ไม่มีรายการเวอร์ชันที่มองเห็นในชุดยืนยันตามตัวกรองนี้</p>
            )}
          </>
        ) : (
          <p className="muted">
            ยังไม่พบข้อมูลยืนยันในขอบเขตนี้ · ไม่สรุปว่ายืนยันหรือไม่ยืนยันแล้ว
          </p>
        )}
      </section>
    </section>
  );
}
